import React, { Component } from "react";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import FooterShade from "../partials/footer";
import TopShade from "../partials/topshade";
//import ShareButtons from "../components/sharebuttons";
import Cookies from "universal-cookie";
import {
  Container,
  Row,
  Col
} from 'react-bootstrap';

const cookies = new Cookies();

const parMums = gql`
query komanda {
  page(id: "cGFnZTo0NQ==") {
    id
    galerija {
      gallery {
        sourceUrl(size: LARGE)
      }
    }
    content(format: RENDERED)
    title(format: RENDERED)
    komanda {
      komandasBiedri {
        teksts
        vards
        foto {
          sourceUrl(size: LARGE)
        }
      }
    }
    translation(language: EN) {
      content(format: RENDERED)
      title(format: RENDERED)
      komanda {
        komandasBiedri {
          teksts
          vards
          foto {
            sourceUrl(size: LARGE)
          }
        }
      }
    }
  }
  themeGeneralSettings {
    optionsPage {
      komanda
      komandaEn
      gimmeMore
      gimmeMoreEn
    }
  }
}

`;

class ParMums extends Component {
  state = {
    dataq: []
  };

  componentDidMount() {
    this.executeNotik();
  }
  executeNotik = async () => {
    const { client } = this.props;
    const props = await client.query({
      query: parMums
    });
    //console.log(props);
    if (!props.data.page) {
      return <p>...</p>;
    }
    const images = props.data.page.galerija.gallery.map((prop, i) => {
      //console.log(prop.sourceUrl);
      return (
        <div
          className={`carousel-item ${i === 0 ? "active" : ""}`}
          key={i}
          style={{
            backgroundImage: `url(${prop.sourceUrl})`
          }}
        ></div>
      );
    });
    //var i = 0;
    const CarouselIndicators = props.data.page.galerija.gallery.map(
      (prop, i) => {
        //console.log(prop.sourceUrl);

        return (
          <li
            data-target="#carouselId"
            data-slide-to={i}
            key={i}
            className={`${i === 0 ? "active" : ""}`}
          ></li>
        );
      }
    );
    const KomandasBiedri = props.data.page.komanda.komandasBiedri.map(
      (komb, i) => {
        //console.log(prop.sourceUrl);

        return (
          <div className="kom-biedrs col-3" key={i}>
            <div className="kom-wrap">
              <div
                className="embed-responsive embed-responsive-1by1 kom-wrap-img"
                style={{
                  backgroundImage: `url(${komb.foto.sourceUrl})`
                }}
              >
              </div>
                <div className="kom-wrap-text embed-responsive-item">
                  <span className="kom-wrap-text-teksts">{komb.teksts}</span>
                  <span className="kom-wrap-text-vards">{komb.vards}</span>
                </div>
            </div>
          </div>
        );
      }
    );
    const KomandasBiedriEn = props.data.page.translation.komanda.komandasBiedri.map(
      (komb, i) => {
        //console.log(prop.sourceUrl);

        return (
          <div className="kom-biedrs col-3" key={i}>
            <div className="kom-wrap">
              <div
                className="embed-responsive embed-responsive-1by1 kom-wrap-img"
                style={{
                  backgroundImage: `url(${komb.foto.sourceUrl})`
                }} title={komb.vards}
              >
              </div>
                <div className="kom-wrap-text embed-responsive-item">
                  <span className="kom-wrap-text-teksts">{komb.teksts}</span>
                  <span className="kom-wrap-text-vards">{komb.vards}</span>
                </div>
            </div>
          </div>
        );
      }
    );
    const dataq = (
      <div id = "parmums"
      data-headertitle = {
          cookies.get("lang") === "LV" ? "Par mums" : cookies.get("lang") === "EN" ? "About Us" : null
                }>
        <div id="carouselId" className="carousel slide narrow-carousel" data-ride="carousel">
          <TopShade />
          <div className="container m-0 p-0">
            <ol className="carousel-indicators">
              {CarouselIndicators.length > 1 ? CarouselIndicators : null}
            </ol>
          </div>
          <div className="carousel-inner" role="listbox">
            {images}
                      <div className="carousel-item-herotextnarrow-wrap">
              <div className="herotext">{cookies.get("lang") === "LV" && props.data.page.title}
              {cookies.get("lang") === "EN" &&
                props.data.page.translation.title}</div>
            </div>
          </div>
          <FooterShade />
        </div>
        <Container className = "single-content-text"
        fluid >
          <Row className = "justify-content-center">
            <Col md = "6"
            className = "single-content-thecontent" >
                          {cookies.get("lang") === "LV" && (
              <div
                dangerouslySetInnerHTML={{ __html: props.data.page.content }}
              />
            )}
            {cookies.get("lang") === "EN" && (
              <div
                dangerouslySetInnerHTML={{
                  __html: props.data.page.translation.content
                }}
              />
            )}
            </Col>
          </Row>
        </Container>
        {/* <div className="container single-content-text">
          {/* <header className="single-header">
            <h2 className="entry-title">
              {cookies.get("lang") === "LV" && props.data.page.title}
              {cookies.get("lang") === "EN" &&
                props.data.page.translation.title}
            </h2>
            <div className="single-share-btns">
              <span>
                {
                  props.data.themeGeneralSettings.optionsPage
                    .singlePostShareButtonsText
                }
              </span>
              <ShareButtons />
            </div>
          </header> }
          <div className="single-content-thecontent">

          </div>
        </div> */}
        <div className = "container komanda-container"
        title = {cookies.get("lang") === "LV" ?
              props.data.themeGeneralSettings.optionsPage.komanda : 
              props.data.themeGeneralSettings.optionsPage.komandaEn}>
          <h2 className="inner-title mt-5 mb-5">
            {cookies.get("lang") === "LV" &&
              props.data.themeGeneralSettings.optionsPage.komanda}
            {cookies.get("lang") === "EN" &&
              props.data.themeGeneralSettings.optionsPage.komandaEn}
          </h2>
          <div className="row">
            
            {cookies.get("lang") === "LV" && KomandasBiedri}
              {cookies.get("lang") === "EN" &&
                KomandasBiedriEn}
            
            </div>
        </div>
      </div>
    );
    this.setState({ dataq });
  };

  render() {
    //console.log(props.data.page.galerija);
    const { dataq } = this.state;
    return <React.Fragment>{dataq}</React.Fragment>;
  }
}
export default withApollo(ParMums);
